import { Component, Input , HostBinding } from '@angular/core';

@Component({
  selector: 'app-data-loader',
  template: `
    <div class="loader-overlay" *ngIf="isLoading">
      <div class="loader-content">
        <mat-spinner [diameter]="diameter"></mat-spinner>
        <p>{{ message }}</p>
      </div>
    </div>
  `,
  styles: [
    `
      .loader-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(243, 240, 240, 0.81); /* Semi-transparent backdrop */
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 100; /* Ensure it stays on top */
      }

      .loader-content {
        text-align: center;
        color: #666;
      }
    `
  ]
})
export class DataLoaderComponent {
  @Input() message: string = 'Loading...'; // Customizable text
  @Input() isLoading: boolean = false;      // Toggle visibility
  @Input() diameter: number = 50;           // Optional: adjustable size

  // This ensures the parent of <app-loader> is always the relative anchor
  @HostBinding('style.position') position = 'relative';
  @HostBinding('style.display') display = 'block';
}
